<template>
  <div id="App">
      <div id="member-left">
          <el-row class="tac">
              <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" >
                <el-menu-item index="1"><router-link :to="{path:'/Member',query: {memberindex: 1,index:4}}">会员中心</router-link></el-menu-item>
                <el-menu-item index="9"><router-link :to="{path:'/Cglist',query: {memberindex: 9,index:4}}">采购需求报送</router-link></el-menu-item>
                <el-menu-item index="2" v-if="info.sf == 1"><router-link  :to="{path:'/MemberInfo',query: {memberindex: 2,index:4}}">选购员管理</router-link></el-menu-item>

                <el-menu-item index="6"><router-link :to="{path:'/MemberPassword',query: {memberindex: 6,index:4}}">修改密码</router-link></el-menu-item>
                <el-menu-item index="8" @click="logout">退出登录</el-menu-item>
              </el-menu>
          </el-row>
      </div>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        activeIndex: '0',
         info:{},
      }
    },

   mounted () {
     let memberindex = this.$route.query.memberindex
     this.activeIndex = memberindex
     this.recordapi();

   },
   methods:{
      recordapi(){
          var that = this;
          var userid = that.$cookieStore.getCookie('userid');
          console.log(userid);
          that.$api.post("/Member/MemberInfos",{'userid':userid}).then(res => {
            console.log(res);
            that.info= res.data.user;
          });
      },

      logout(){
        console.log(1);
          this.$confirm('确定要退出登录吗?', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
            }).then(() => {
              this.$message({
                 type: 'success',
                 message: '退出成功!'
               });
               //确认退出，清除token
              this.$cookieStore.delCookie('userid');
              // localStorage.removeItem('token')
               //跳转登录页面(编程式导航)
               this.$router.push('/login')

          }).catch(() => {
          this.$message({
          type: 'info',
          message: '已取消退出'
          });
        });
      },



   }

   }
</script>



// WEBPACK FOOTER //
// src/components/public/memberleft.vue